import React, { Component } from 'react';
import UserContainer from 'src/components/parts/UserContainer';
import {Helmet} from 'react-helmet';
import { connect } from "react-redux";
import { setText, setUsers } from "src/cms.js";


//	This maps the data store to local variables.
const mapStateToProps = state  => {
	return {
	  meta_title: state.meta_title,
	  meta_description: state.meta_description,
	  content: state.content,
	  firstLoad: state.firstLoad
	};
};

//	Main Home Class
class Home extends Component {

	constructor(props) {

		super(props);

		
		if( process.env.NODE_ENV === 'development' || this.props.firstLoad === false ) {

			this.props.dispatch({type: 'GET_ALL_USERS_RESET'});	// after getting initial users will allow for when scroll happens will get all users again

			props.dispatch({type: 'RESET_SHOW_USERS'});

			setUsers(props);

			setText(props);

		}
		
	}

	//	When url changes for example /tag/latina/ to /tag/ebony/
	componentDidUpdate(prevProps, prevState) {
		
		if( this.props.location.pathname !== prevProps.location.pathname) {

			this.props.dispatch({type: 'GET_ALL_USERS_RESET'});	// after getting initial users will allow for when scroll happens will get all users again

			if( process.env.NODE_ENV === 'development' || this.props.firstLoad === false ) {

				this.props.dispatch({type: 'RESET_SHOW_USERS'});	// Set number of users to show back to default.

				setUsers(prevProps);

				setText(prevProps);

			}

		}
		
	}


	render() {
	  return (
		<div>
			<UserContainer showOrderBox={true} />
			<div>
				{this.props.content}
			</div>
			<Helmet>
				<title>{this.props.meta_title}</title>
				<meta name="description" content={this.props.meta_description} />
			</Helmet>
        </div>
	  );
	}
}

//	Export with redux connections.
export default connect(mapStateToProps)(Home);


// WEBPACK FOOTER //
// ./src/components/pages/Home.js